module.exports = __webpack_public_path__ + "img/mb-visual-background.f199a974.png";